<template>
  <div>
    <section class="mb-4 mb-lg-5">
      <div class="container">
        <div class="image-header" :style="coverImage">
          <label for="cover" class="btn btn-outline-color2">Adicionar imagem</label>
          <input
            type="file"
            name="cover"
            id="cover"
            style="display: none"
            @change="changeCover"
            accept="image/*"
          />
        </div>
        <p class="font-size-xSmall mt-2 text-color2 mb-0 text-center text-lg-left">Tamanho ideal: 1110px x 350px</p>
      </div>
    </section>
    <CropperModal
      :src="cropSrc"
      @cropped="setCover"
    />

    <section class="mb-5">
      <div class="container text-center">
        <div class="col-lg-10 mx-auto">
          <div class="form-group mb-4">
            <input
              type="text"
              class="form-control font-weight-bold font-size-medium bordered-bottom"
              name="name"
              placeholder="Nome"
              v-model.trim="$v.group.name.$model"
              @blur="setSlug"
            />
          </div>
          <div class="form-group mb-4 col-md-8 mx-md-auto editable-form">
            <span class="font-size-small">{{ baseUrl }}/communities/</span>
            <input
              type="text"
              class="form-control bordered-bottom font-size-small pb-0 text-left font-weight-bold text-color2"
              name="slug"
              placeholder="URL"
              v-model.trim="$v.group.slug.$model"
            />
          </div>
          <div class="form-group mb-5 col-md-6 mx-md-auto">
            <textarea
              class="form-control bordered-bottom font-size-small w-100"
              name="description"
              placeholder="Escreva aqui uma descrição para sua comunidade"
              v-model.trim="group.description"
            ></textarea>
            <p class="font-size-small text-right">
              <span
                class="d-inline-block"
                :class="{
                  'text-color4': group.description.length > 700
                }"
              >
                {{ group.description.length }}
              </span>/700
            </p>
          </div>

          <!-- MODERATION -->
          <div class="form-group mb-4">
            <div class="col-md-4 mx-md-auto">
              <label class="font-size-medium font-weight-bold d-block">
                Moderação
              </label>
            </div>
            <div
              class="col-md-6 mx-md-auto"
            >
              <div class="default-form">
                  <div class="styled-checkbox">
                    <label for="is_public_posting_enabled">
                      <input
                        id="is_public_posting_enabled"
                        type="checkbox"
                        name="is_public_posting_enabled"
                        v-model="group.is_public_posting_enabled"
                      />
                      <span></span>
                      Habilitar publicações de todos os membros
                    </label>
                  </div>
              </div>
            </div>
          </div> <!-- END MODERATION -->

          <!-- TAGS -->
          <div class="form-group mb-4">
            <div class="col-md-4 mx-md-auto">
              <label class="font-size-medium font-weight-bold d-block">
                Tags
                <i
                  class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                  v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                  :title="this.tagsTooltipText"
                  >
                </i>
              </label>
              <input
                type="text"
                class="form-control bordered-bottom font-size-small pb-0 px-0 w-100"
                name="tag"
                placeholder="Separe tags com enter ou vírgula"
                v-model="tag"
                @keyup.enter.188.prevent="storeTag"
              />
            </div>
            <div
              class="col-md-6 mx-md-auto"
              v-if="group.tags.length > 0"
            >
              <ul
                class="tag-list d-flex mt-4 flex-wrap justify-content-center"
              >
                <li
                  class="tag-item mb-3 mr-4 font-size-regular"
                  v-for="(tag, index) in group.tags"
                  :key="index"
                >
                  <span class="tag">{{ tag }}</span>
                  <button
                    type="button"
                    class="remove-tag"
                    @click="removeTag(tag, index)"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div> <!-- END TAGS -->

          <!-- AMOUNT -->
          <div class="form-group mb-4" v-if="1 == 2">
            <div class="col-md-8 mx-md-auto">
              <label class="font-size-medium font-weight-bold d-block">Digite o preço da comunidade</label>
            </div>
            <!-- RECEIVABLE CONFIGURATION WRAPPER -->
            <div
              class="receivable-conf"
              v-if="user && !user.is_receivable_configured"
            >
              <div class="mx-auto col-md-6">
                <div>
                  <BaseIcon
                    size="medium"
                  >
                    <LockIcon />
                  </BaseIcon>
                </div>
                <h2 class="font-weight-bold font-size-regular text-color2">Quase lá!</h2>
                <p class="font-size-small">Precisamos de mais algumas informações para habilitar a funcionalidade de venda!</p>
                <Button
                  class="btn-sm btn-outline-color2 px-3 mb-3"
                  v-b-modal.user-receivable-info
                >
                  Preencher informações
                </Button>
                <p class="font-size-small mb-md-0">Caso a comunidade seja gratuita, pode seguir normalmente.</p>
              </div>
              <UserReceivableInfoModal
                @receivable-created="parseReceivable"
              />
            </div> <!-- END RECEIVABLE CONFIGURATION WRAPPER -->
            <!-- PRICE WRAPPER -->
            <div v-else-if="user && user.is_receivable_configured">
              <div class="col-md-4 mx-md-auto">
                <Money
                  class="form-control bordered-bottom font-size-regular font-weight-bold text-color2 pb-0 px-0 w-100"
                  v-model="group.amount"
                  v-bind="money"
                />
              </div>
              <div class="col-md-6 mx-md-auto">
                <p class="font-size-xSmall mt-2 text-center text-color2 mb-0" v-if="group.amount > 9999">Valor máximo de: R$ 9999,00</p>
                <p class="font-size-xSmall mt-2 mb-0 text-center">Comunidades sem valor serão acessíveis gratuitamente</p>
                <p
                  class="font-size-xSmall text-center"
                  v-if="group.amount > 0 && group.amount < parsedMinimumGroupAmount"
                >
                  O valor mínimo é de <strong>{{ parsedMinimumGroupAmount | formatMoney }}</strong>
                </p>
                <p class="mt-2 mb-0 text-center">
                  <router-link
                    class="font-size-xSmall text-color2 text-decoration-underline"
                    target="_blank"
                    :to="{ name: 'statics.wallet' }"
                  >
                    Entenda as nossas taxas e como elas são cobradas
                  </router-link>
                </p>
              </div>
              <div
                class="text-center mt-3 font-size-small"
                v-if="group.amount > 0"
              >
                <p>
                  <strong>Valor cobrado:</strong> {{ group.amount | formatMoney }}<br/>
                  <strong>Taxa Scriv:</strong>
                    {{ scrivFee }}%
                    <span
                      id="tooltip-fees"
                      class="text-color2"
                      style="cursor:pointer;"
                      >
                        <i class="fa fa-info-circle"></i>
                    </span>
                    <b-tooltip custom-class="font-size-xSmall" target="tooltip-fees" triggers="hover">
                      <p>As taxas retidas representam {{ (group.amount * scrivFee / 100) | formatMoney }} do valor total de {{ group.amount | formatMoney }}.</p>
                      <p>Neste valor estão inclusos os custos de impostos, transações financeiras, anti-fraude para pagamentos e toda a operação da Scriv (equipe, servidores, custos administrativos e jurídicos).</p>
                      <p>Para mais informações, acesse a página <router-link class="font-weight-bold" target="_blank" :to="{ name: 'statics.wallet' }" style="color: #EA6C54 !important;">Scriv Wallet</router-link>.</p>
                    </b-tooltip>
                    <br/>
                  <strong>Valor líquido a receber:</strong> {{ (group.amount * (user.partner_group.split / 100 / 100)) | formatMoney }}
                </p>
                <p>
                  <strong>Opções de pagamento disponíveis</strong><br/>
                  <span class="d-block">Cartão de crédito</span>
                  <span class="d-block">
                    <span
                      :class="{
                      'text-strike': group.amount < minimumAmountForBoleto
                      }"
                      >
                      Boleto bancário
                    </span>
                    <i
                      class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                      v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                      :title="`A opção de boleto ficará disponível a partir de ${ $options.filters.formatMoney(minimumAmountForBoleto) }`"
                      >
                    </i>
                  </span>
                  <span class="d-block">PIX</span>
                </p>
              </div>
            </div> <!-- END PRICE WRAPPER -->
          </div><!-- END AMOUNT -->

          <!-- ACTIONS -->
          <div class="form-group mt-5">
            <Button
              class="btn-primary mb-3 mb-md-0"
              type="button"
              :disabled="$v.$invalid"
              :loading="loader"
              @click="submit()"
            >
              <template
                v-if="$route.name === 'groups.create'"
              >
                Criar
              </template>
              <template
                v-else
              >
                Salvar
              </template>
            </Button>
            <router-link
              class="btn btn-outline-color2 ml-md-3"
              :to="'/'"
            >
              Cancelar
            </router-link>
          </div> <!-- END ACTIONS -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import { required, between } from 'vuelidate/lib/validators'
import variables from '@/mixins/variables'
import { mapState } from 'vuex'
import { slugify, checkIfUserIsOwnerOfEntity } from '@/utils'
import GroupsService from '@/modules/groups/services/groups-service'
import UsersService from '@/modules/users/services/users-service'

import Button from '@/components/common/Button/Button.vue'
// import DropdownSelect from '@/components/common/Select/DropdownSelect.vue'
import CropperModal from '@/components/common/Cropper/CropperModal'
// import Loader from '@/components/common/Loader/Loader.vue'
import { Money } from 'v-money'
import UserReceivableInfoModal from '@/components/user/UserReceivableInfoModal'

import BaseIcon from '@/components/common/Icon/BaseIcon'
import LockIcon from '@/components/common/Icon/LockIcon'

export default {
  mixins: [variables],
  components: {
    BaseIcon,
    Button,
    CropperModal,
    LockIcon,
    Money,
    UserReceivableInfoModal
  },
  data () {
    return {
      loader: false,
      currentGroup: null,
      cropSrc: '',
      tag: '',
      group: {
        name: '',
        slug: '',
        description: '',
        amount: 0,
        tags: [],
        cover: null,
        type: 'default',
        visibility: 'public',
        is_public_posting_enabled: false
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }
  },
  metaInfo () {
    return {
      title: this.$route.name === 'groups.create' ? 'Criar comunidade' : 'Editar comunidade'
    }
  },
  validations () {
    return {
      group: {
        name: { required },
        slug: { required },
        amount: {
          between: between(0, 9999)
        }
      }
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    coverImage () {
      return {
        backgroundImage: this.group.cover ? `url('${URL.createObjectURL(this.group.cover)}')` : `url('${this.currentGroup ? this.currentGroup.cover : this.noCoverUrl}')`
      }
    },
    scrivFee () {
      return this.user ? 100 - (this.user.partner_group.split / 100) : 0
    },
    parsedMinimumGroupAmount () {
      return this.minimumGroupAmount / 100
    },
    parsedBoletoFee () {
      return this.boletoFee / 100
    },
    minimumAmountForBoleto () {
      return this.user ? (100 * this.parsedBoletoFee) / this.scrivFee : 0
    }
  },
  watch: {
    user (newUser, oldUser) {
      if (!this.currentGroup) this.getGroup()
    }
  },
  created () {
    if (this.user) this.getGroup()
  },
  methods: {
    async getGroup () {
      const routeName = this.$route.name
      if (routeName === 'groups.edit') {
        try {
          const group = await GroupsService.getGroup(this.$route.params.slug)
          checkIfUserIsOwnerOfEntity(group, this.user)
          this.setGroup(group)
        } catch (error) {
          // If there is an error, redirect to home
          this.$router.push('/')
        }
      }
    },
    setGroup (group) {
      this.currentGroup = group
      this.group.name = group.name
      this.group.slug = group.slug
      this.group.description = group.description ? group.description : ''
      this.group.visibility = group.visibility
      this.group.is_public_posting_enabled = group.is_public_posting_enabled
      this.group.tags = []
      group.tags.forEach(tag => {
        this.group.tags.push(tag.name)
      })
      let amount = 0
      if (group.amount !== null) {
        amount = (parseInt(group.amount) / 100)
      }
      this.group.amount = amount
    },
    changeCover (e) {
      const file = e.target.files[0]
      // this.book.cover = file
      this.cropSrc = URL.createObjectURL(file)
    },
    setCover (blob) {
      this.group.cover = blob
    },
    setSlug () {
      if (!this.group.slug) {
        this.group.slug = slugify(this.group.name)
      }
    },
    storeTag (e) {
      const value = e.target.value.replace(',', '').replaceAll('#', '').trim()
      if (!this.group.tags.includes(value)) {
        this.group.tags.push(value)
      }
      this.tag = ''
    },
    removeTag (tag, index) {
      this.group.tags.splice(index, 1)
    },
    async submit () {
      this.loader = true
      try {
        const id = this.currentGroup ? this.currentGroup.id : null
        const group = await GroupsService.post(id, this.group)
        this.$router.push({ name: 'groups.show', params: { slug: group.slug } })
      } catch (error) {
        console.log(error)
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    async parseReceivable () {
      await UsersService.me()
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-item {
  position: relative;

  .remove-tag {
    border: none;
    padding: 0;
    margin: 0;
    background: #fff;
    border-radius: 30px;
    position: absolute;
    top: -10px;
    right: -15px;
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    color: $color4;
    font-size: $font_size_xSmall;
  }
}
</style>
